export default __webpack_public_path__ + "2010b751f42f5118a002b9ca762e8456.svg";